import React from "react";

const Login = () => {
  return <div className="page-content">Login Page</div>;
};

export default Login;
